import { mapSourceVacancyToFilters } from '../sources/sourceModules';

export const normalizeSpecializationList = (value: unknown): string[] => {
  if (Array.isArray(value)) {
    return value.map(String).map((item) => item.trim()).filter(Boolean);
  }

  if (typeof value === 'string' && value.trim()) {
    return value.split(',').map((item) => item.trim()).filter(Boolean).map(String);
  }

  return [];
};

export const getVacancySpecializationsForSource = (
  vacancy: Record<string, unknown> | null | undefined,
  source: string,
): string[] => {
  if (!vacancy) return [];
  return normalizeSpecializationList(
    mapSourceVacancyToFilters(source, { vacancy }).selectedSpecializations,
  );
};

export const buildVacancyDataHash = (
  vacancy: Record<string, any> | null | undefined,
): string => {
  if (!vacancy) return '';

  return JSON.stringify({
    id: vacancy.id,
    title: vacancy.title,
    description: vacancy.description,
    topics: vacancy.topics,
    skillGroups: vacancy.skillGroups,
    cities: vacancy.cities,
    salaryFrom: vacancy.salaryFrom,
    salaryTo: vacancy.salaryTo,
    salaryCurrency: vacancy.salaryCurrency,
    salarySpecified: vacancy.salarySpecified,
    education: vacancy.education
      ? String(vacancy.education).split(',').map((value) => value.trim()).filter(Boolean)
      : [],
    experienceInPosition: vacancy.experienceInPosition,
    experiencePeriod: vacancy.experiencePeriod,
    totalExperience: vacancy.totalExperience,
    excludeJumpers: Boolean(vacancy.excludeJumpers),
    filterByExpIndustry: Boolean(vacancy.filterByExpIndustry),
    scoringEnabled: vacancy.scoringEnabled !== false,
    candidateStatuses: vacancy.candidateStatuses,
    industry: vacancy.industry,
    specialization: vacancy.specialization,
    avitoSpecialization: vacancy.avitoSpecialization,
    avitoLocationIds: vacancy.avitoLocationIds,
    gender: vacancy.gender,
    ageFrom: vacancy.ageFrom,
    ageTo: vacancy.ageTo,
    citizenship: Array.isArray(vacancy.citizenship)
      ? vacancy.citizenship
      : typeof vacancy.citizenship === 'string' && vacancy.citizenship.trim()
      ? vacancy.citizenship.split(',').map((value: string) => value.trim()).filter(Boolean)
      : [],
    useMetroInSearch: vacancy.useMetroInSearch,
    officeLocations: vacancy.officeLocations,
    officeCityId: vacancy.officeCityId,
    workFormat: vacancy.workFormat,
    workSchedule: vacancy.workSchedule,
    workingHours: vacancy.workingHours,
    strictRegionSearch: vacancy.strictRegionSearch,
  });
};
